<script>
    import GraficoLine from "../graphics/graficoLIne.svelte";
    import GraficoBar from "../graphics/graficoBar.svelte";
    export let data = {
        name: "",
        data: "",
    };
    /* "line" for a series over time, "bar" for a comparison between tables */
    export let kind = "line";
</script>


<div class="col-md-6">
    <!-- AREA CHART -->
    <div class="card card-secondary">
        <div class="card-header">
            <h3 class="card-title">{data.name}</h3>

            <div class="card-tools">
                <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                >
                    <i class="fas fa-times" />
                </button>
            </div>
        </div>

        <div class="card-body pt-1">
            {#if kind === "bar"}
                <GraficoBar data={data.data} />
            {:else}
                <GraficoLine data={data.data} />
            {/if}
        </div>

        <!-- /.card-body -->
    </div>
    <!-- /.card -->
</div>
